import React from 'react';
import { Typography } from '@mui/material';
import { formatDate, formatTime } from 'utils/momentHelpers';
import countries from '../../../../../../data/countries';
import { StyledNextAppointmentTime, StyledNextAptWrapper } from './styles';

const DS_NextAppointmentDateTime = ({
  label,
  availableDay,
  availableTime,
  withWrapper = false,
  nextAppointmentTranslation,
  isLocationSelected,
}) => {
  if (!availableDay || !availableTime) return;
  const country = countries[process.env.GATSBY_COUNTRY_CODE];
  const isFrance = country.lang === 'fr';
  const RenderContent = () => {
    return (
      <>
        <Typography variant="DS_copySmallRegular" component="p">
          {label || nextAppointmentTranslation}
        </Typography>

        <StyledNextAppointmentTime
          variant="DS_copySmallRegular"
          component="div"
          className={isLocationSelected && 'selected'}
        >
          {`${formatDate(availableDay)}${isFrance ? ' : ' : ': '}${formatTime(availableTime)}`}
        </StyledNextAppointmentTime>
      </>
    );
  };

  return withWrapper ? (
    <StyledNextAptWrapper>
      <RenderContent />
    </StyledNextAptWrapper>
  ) : (
    <RenderContent />
  );
};

export default DS_NextAppointmentDateTime;
